import axios from "axios";
import API_BASE_URL from "../../../config/apiConfig";

const API_URL = `${API_BASE_URL}/api/PatientInfo/high-risk`;

export const getHighRiskPatients = async (cipId = null, locationId = null, memberType = null) => {
  try {
    const response = await axios.get(API_URL, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`
      },
      params: {
        cipId,
        locationId,
        memberType
      }
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching high risk patients:", error);
    throw error;
  }
};
